import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MSmClientOpportunityEntity } from './m-sm-client-opportunity.entity';

@Index('opp_stage_history__fk_opportunity__id', ['fkOpportunityId'], {})
@Index('opp_stage_history__created_date', ['createdDate'], {})
@Entity('opportunity_stage_history')
export class OpportunityStageHistoryEntity extends BaseEntity {
	@Column('int', { name: '_fk_opportunity__id', unsigned: true })
	public fkOpportunityId!: number;

	@Column('varchar', { name: 'stage_name_old', nullable: true, length: 100 })
	public stageNameOld!: string | null;

	@Column('varchar', { name: 'stage_name_new', length: 100 })
	public stageNameNew!: string;

	@ManyToOne(
		() => MSmClientOpportunityEntity,
		(opportunity) => opportunity.stageHistories,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk_opportunity__id', referencedColumnName: 'id' }])
	public fkOpportunity!: MSmClientOpportunityEntity;
}
